import * as React from "react"
import { graphql } from "gatsby"
import { mapEdgesToNodes, filterOutDocsWithoutSlugs } from "../lib/helpers"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Hero from "../components/hero"
import HomeCategories from "../components/home-categories"
import HomeFeatured from "../components/home-featured"
import HomeAbout from "../components/home-about"
import HomeBlocks from "../components/home-blocks"
import ContactLocation from "../components/contact-location"

export const query = graphql`
  query {
    categories: allSanityTrailerCategory {
      edges {
        node {
          id
          title
          slug {
            current
          }
          image {
            asset {
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
`

const IndexPage = props => {
  const { data, errors } = props
  if (errors) {
    return "GraphQl Error!"
  }

  const categoryNodes = (data || {}).categories
    ? mapEdgesToNodes(data.categories).filter(filterOutDocsWithoutSlugs)
    : []

  return (
    <Layout>
      <Hero />
      <HomeCategories nodes={categoryNodes} />
      <HomeFeatured />
      <HomeAbout className={"pt-16 md:py-16"} />
      <ContactLocation className={"pb-16"} />
      <HomeBlocks className={"py-6 md:py-16 bg-grey-100"} />
    </Layout>
  )
}

export default IndexPage

export const Head = () => (
  <Seo
    title={"Ifor Williams Trailers"}
    description={
      "Based to the North of Norwich, Norfolk Trailers are sole distributors for Ifor Williams Trailers in Norfolk."
    }
  />
)
